<div class="layout-container">
  <div class="main-content">
    <app-header class="header"></app-header>
    <div class="content-wrapper">
      <app-sidebar class="sidebar"></app-sidebar>
      <main class="router-container">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>
